module.exports = __webpack_public_path__ + "img/file.a7d1b24c.svg";